module.exports = __webpack_public_path__ + "static/img/RhythmPlanet.878fdc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vidio/RhythmPlanet.jpg
// module id = tzkB
// module chunks = 0